/** @format */
// components/Hero.tsx
import React from "react";
import {
  Box,
  Typography,
  Container,
  Button,
  Grid,
  useMediaQuery,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import pillar from "../assets/images/pillar.png";
import sandbox from "../assets/images/sandbox.png";
import masschallenge from "../assets/images/masschallenge.png";

import appMockup from "../assets/images/mockup.gif"; // Add this smartphone mockup image
import mockupOverlay from "../assets/images/mockup-overlay.png"; // Add this overlay image
import testflight from "../assets/images/testflight.png"; // Add this TestFlight icon
import googleplay from "../assets/images/googleplay.png"; // Add this Google Play icon
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    minHeight: "100vh",
    backgroundColor: theme.palette.primary.main,
    color: "#ffffff",
    display: "flex",
    flexDirection: "column",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    minHeight: "100vh",
    paddingTop: theme.spacing(15),
    [theme.breakpoints.down("md")]: {
      paddingTop: theme.spacing(15),
      paddingBottom: theme.spacing(10),
    },
    [theme.breakpoints.down("sm")]: {
      paddingBottom: theme.spacing(10),
    },
  },
  contentWrapper: {
    display: "flex",
    flex: 1,
    width: "100%",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    maxWidth: "55%",
    [theme.breakpoints.down("md")]: {
      maxWidth: "100%",
      textAlign: "center",
      marginBottom: theme.spacing(4),
    },
  },
  mockupContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    position: "relative",
    height: "100%",
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(4),
    },
  },
  mockupWrapper: {
    position: "relative",
    display: "inline-block",
    height: "80vh",
    [theme.breakpoints.down("md")]: {
      // height: "50vh",
    },
    [theme.breakpoints.down("sm")]: {
      // height: "40vh",
      // width: "100%", // Take full width of container on small screens
      // display: "flex",
      justifyContent: "center",
    },
  },
  mockupImage: {
    height: "100%",
    width: "auto",
    display: "block",
    [theme.breakpoints.down("sm")]: {
      height: "auto",
      maxHeight: "100%",
      // maxWidth: "95%", // Increased from 85% to 95% to make it larger
      margin: "0 auto",
    },
  },
  mockupOverlay: {
    position: "absolute",
    top: -7,
    left: -15,
    height: "calc(100% + 10px)",
    width: "auto",
    maxWidth: "none",
    zIndex: 2,
    [theme.breakpoints.down("sm")]: {
      top: -10,
      // left: "50%",
      // transform: "translateX(-50%)",
      // height: "calc(88% + 0px)",
      // width: "auto",
      // maxWidth: "calc(100% + 10px)", // Match the updated mockupImage width plus a small offset
    },
  },
  titleContainer: {
    marginBottom: theme.spacing(8),
    [theme.breakpoints.down("md")]: {
      marginBottom: theme.spacing(4),
    },
  },
  title: {
    fontSize: "5rem !important",
    fontWeight: 300,
    lineHeight: 1.2,
    [theme.breakpoints.down("md")]: {
      fontSize: "4rem !important",
    },
    "@media (max-width: 880px)": {
      // Custom breakpoint at 1150px
      fontSize: "3rem !important",
    },
    "@media (max-width: 1200px)": {
      // Custom breakpoint at 1150px
      fontSize: "3.8rem !important",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "2.5rem !important",
    },
  },
  subtitle: {
    fontSize: "1.5rem",
    maxWidth: "800px",
    fontWeight: 300,
    [theme.breakpoints.down("md")]: {
      fontSize: "1.2rem",
      maxWidth: "100%",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem",
    },
  },
  boldText: {
    fontWeight: "bold",
    background:
      "linear-gradient(to right, #FF9250, #FF6473, #FE26A0, #CF34B9, #7852DC, #017AFF)",
    "-webkit-background-clip": "text",
    backgroundClip: "text",
    color: "transparent",
    "-webkit-text-fill-color": "transparent",
  },
  availabilitySection: {
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(3),
    },
  },
  availabilityText: {
    fontSize: "1.2rem",
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem",
      marginBottom: theme.spacing(3),
    },
  },
  storeIcons: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(20),
    marginBottom: theme.spacing(5),
    "@media (max-width: 1300px)": {
      gap: theme.spacing(4),
      justifyContent: "center",
      flexDirection: "column",
    },
  },
  storeIcon: {
    height: "50px",
    [theme.breakpoints.down("sm")]: {
      height: "40px",
    },
  },
  waitlistButton: {
    fontSize: "1.2rem",
    borderRadius: "25px !important",
    background:
      "linear-gradient(to right, #FF9250, #FF6473, #FE26A0, #CF34B9, #7852DC, #017AFF)",
    color: "#ffffff",
    border: "none",
    textTransform: "none",
    marginTop: theme.spacing(0),
    marginLeft: theme.spacing(8),
    height: "50px",
    width: "200px",
    padding: "8px 24px",
    position: "relative",
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: "10px",
      left: "50%",
      width: "0",
      height: "2px",
      backgroundColor: "#ffffff",
      transition: "all 0.3s ease-in-out",
      transform: "translateX(-50%)",
    },
    "&:hover::after": {
      width: "70%",
    },
    "@media (max-width: 100px)": {
      marginLeft: theme.spacing(0),
      marginTop: theme.spacing(4),
      fontSize: "1rem",
      height: "45px",
    },
  },
  partners: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    "& img": {
      height: "30px",
      marginRight: theme.spacing(4),
      [theme.breakpoints.down("sm")]: {
        height: "30px",
        marginRight: theme.spacing(2),
      },
    },
    marginTop: theme.spacing(-5),
    [theme.breakpoints.down("md")]: {
      justifyContent: "center",
      flexWrap: "wrap",
      gap: theme.spacing(2),
      marginTop: theme.spacing(5),
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(8),
    },
  },
}));

const Hero: React.FC = () => {
  const classes = useStyles();
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("md")
  );

  return (
    <Box className={classes.root}>
      <Container maxWidth="xl" className={classes.container}>
        <Box className={classes.contentWrapper}>
          <Box className={classes.content}>
            <Box className={classes.titleContainer}>
              <Typography variant="h1" className={classes.title}>
                Your Body Talks
                <br />
                We Translate
              </Typography>
            </Box>
            <Typography variant="h5" className={classes.subtitle}>
              Introducing <span className={classes.boldText}>EON.HEALTH</span>,
              your AI Companion for a Unique Journey to Holistic Longevity and
              Maximum Functionality.
            </Typography>

            <Box className={classes.availabilitySection}>
              <Typography className={classes.availabilityText}>
                Available on
              </Typography>
              <Box className={classes.storeIcons}>
                <Box
                  sx={(theme) => ({
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    [theme.breakpoints.down("md")]: {
                      justifyContent: "center",
                    },
                  })}
                >
                  <img
                    src={testflight}
                    alt="Available on TestFlight"
                    className={classes.storeIcon}
                  />
                  <img
                    src={googleplay}
                    alt="Get it on Google Play"
                    className={classes.storeIcon}
                  />
                </Box>
                <Link to="/join">
                  <Button
                    variant="contained"
                    className={classes.waitlistButton}
                  >
                    Join The Waitlist
                  </Button>
                </Link>
              </Box>
            </Box>
          </Box>

          {/* Only show mockup if it will fit properly */}
          <Box className={classes.mockupContainer}>
            <Box className={classes.mockupWrapper}>
              <img
                src={appMockup}
                alt="EON.HEALTH App"
                className={classes.mockupImage}
              />
              <img
                src={mockupOverlay}
                alt="EON.HEALTH App Overlay"
                className={classes.mockupOverlay}
              />
            </Box>
          </Box>
        </Box>

        <Box className={classes.partners}>
          <img src={sandbox} alt="MIT Sandbox" />
          <img src={pillar} alt="MIT-Pillar AI Collective" />
          <img src={masschallenge} alt="MassChallenge" />
        </Box>
      </Container>
    </Box>
  );
};

export default Hero;
